import { action as apiAction } from 'api/Api'

type Payload = {
  cardId: number
  name: string
  timestamp: number
}

export default (payload: Payload) => async () => {
  const { cardId, name, timestamp } = payload

  await apiAction('AddCustomDate', {
    cardId,
    timestamp,
    name: name.trim()
  })
}
